import React, { useEffect, useState, useImperativeHandle, forwardRef, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import localforageWrapper from './localforageWrapper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import "./Header.css";
import { Display } from "react-7-segment-display";
import ConfirmationModal from "./ConfirmationModal"; // Import the custom modal



const TokenDisplayScreen = forwardRef((props, ref) => {
    const [hindiVoice, setHindiVoice] = useState(null);
    const [englishVoice, setEnglishVoice] = useState(null);
    const [voicesLoaded, setVoicesLoaded] = useState(false);
    const [isSpeechEnabled, setIsSpeechEnabled] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false); // Track if audio is playing
    const [queue, setQueue] = useState([]); // Queue for token playback
    const [tokenData, setTokenData] = useState([]);
    const [processedTokens, setProcessedTokens] = React.useState(new Set());
    const [blinkingCard, setBlinkingCard] = useState(null);
    const [tokenKey, setTokenKey] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(true);
    const [isPlaying, setIsPlaying] = useState(false); // State to track if the video is playing
    const videoRef = useRef(null); // Ref to access the video element



    useEffect(() => {

        const dialogShown = localStorage.getItem("dialogShown");
        if (!dialogShown) {
            setShowConfirmationModal(true); // Show the dialog if it hasn't been shown before
        }

        /*  // Get the current date in YYYY-MM-DD format
         const currentDate = new Date().toISOString().split('T')[0];
 
         // Get the stored date from localStorage
         const storedDate = localStorage.getItem("lastDialogDate");
 
         // Show the dialog if the stored date is not equal to the current date
         if (storedDate !== currentDate) {
             setShowConfirmationModal(true); // Show the dialog
             localStorage.setItem("lastDialogDate", currentDate); // Update the stored date
         } */


        let timer;
        fetchRunningTokens();
        // Set the current blinking card when a new token is received
        if (tokenKey) {
            setBlinkingCard(tokenKey);
            // Start the timer to stop blinking after 3 seconds
            timer = setTimeout(() => {
                setBlinkingCard(null); // Stop blinking
            }, 5000);
        }

        const connection = new signalR.HubConnectionBuilder()
            .withUrl("https://www.tokenapi.binix.co.in/hubs/chat")
            .withAutomaticReconnect()
            .build();
        /* const connection = new signalR.HubConnectionBuilder()
            .withUrl("http://localhost:44389/hubs/chat")
            .withAutomaticReconnect()
            .build(); */

        connection
            .start()
            .then(() => {
                console.log("SignalR Connected (Token Display Screen)");
                //connection.off("ReceiveToken");
                if (!connection._listeners || !connection._listeners["ReceiveToken"]) {
                    connection.on("ReceiveToken", (token) => {
                        debugger;
                        console.log("Token received:", token);
                        /* setCurrentToken(token.tokenNo); */
                        setTokenKey(token.key);
                        // Check if the token is already processed
                        setProcessedTokens((prevToken) => {
                            if (prevToken === token) {
                                console.warn("Duplicate token ignored:", token.tokenNo);
                                return prevToken; // Ignore duplicate
                            }

                            handleTokenReceived(token);
                            return token; // Replace with the new token number

                        });


                    });
                    connection._listeners = { ...connection._listeners, "ReceiveToken": true };
                }
            })
            .catch((error) => console.error("SignalR Connection Error:", error));

        //loadVoices();
        return () => {
            clearTimeout(timer); // Cleanup the timer when the component unmounts or re-renders
            connection.stop(); // Stop the SignalR connection
        };
    }, [isSpeaking]);

    // Function to handle play/pause
    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause(); // Pause the video
            } else {
                videoRef.current.play(); // Play the video
            }
            setIsPlaying(!isPlaying); // Toggle the state
        }
    };
    const handleConfirmation = (confirmed) => {
        if (confirmed) {
            enableSpeech(); // Clear history and initialize speech
        }
        localStorage.setItem("dialogShown", "true");
        setShowConfirmationModal(false); // Close the modal
    };

    async function fetchRunningTokens() {
        const runningData = await localforageWrapper.getItem('myData');
        setTokenData(runningData || []); // Set to [] if runningData is null or undefined
    }

    // Handle new tokens received
    const handleTokenReceived = async (token) => {
        debugger;
        setQueue((prevQueue) => {
            const updatedQueue = [...prevQueue, token]; // Add the token to the queue

            if (!isSpeaking) {
                processQueue(updatedQueue); // Start processing if not already speaking
            }
            return updatedQueue; // Update the state with the new queue
        });
        const newNode = {
            key: token.counter + '-' + token.tokenNo,
            tokenNo: token.tokenNo,
            drName: token.drName,    // Doctor's name
            description: token.description,    // Description
            counter: token.counter,    // Counter No
            language: token.language,     // Patient's name
        };
        updateOrAddNode(newNode);
    };

    const updateOrAddNode = async (newNode) => {
        try {
            debugger;
            const value = await localforageWrapper.getItem('myData');
            let prevData = Array.isArray(value) ? value : [];

            const nodeIndex = prevData.findIndex(
                (node) =>
                    //node.key === newNode.counter + '-' + newNode.tokenNo &&
                    node.drName === newNode.drName &&
                    node.counter === newNode.counter
            );

            if (nodeIndex !== -1) {
                // Update existing node
                prevData[nodeIndex].key = newNode.counter + '-' + newNode.tokenNo;
                prevData[nodeIndex].drName = newNode.drName;
                prevData[nodeIndex].tokenNo = newNode.tokenNo;
                prevData[nodeIndex].description = newNode.description;
                prevData[nodeIndex].language = newNode.language;
                /*
                               //remove selectedIndex
                               prevData = prevData.filter(
                                   (node) =>
                                       node.hotelcode !== hotelcode ||
                                       node.rtcode !== rtcode ||
                                       node.ratecode !== ratecode ||
                                       node.ocode !== ocode
                               );
                               await localforageWrapper.setItem('myData', prevData); */
            } else {
                //Add new node
                prevData = [...prevData, newNode];
            }

            await localforageWrapper.setItem('myData', prevData);
            setTokenData(prevData);
            console.log('Data saved:', prevData);


        } catch (error) {
            console.error('Error updating/adding node:', error);
        }
    };
    // Process the queue
    const processQueue = (currentQueue) => {
        if (currentQueue.length === 0) {
            console.log("Queue is empty, nothing to process.");
            setIsSpeaking(false); // Set isSpeaking to false when the queue is empty
            return; // No tokens to process
        }

        const [currentToken, ...remainingQueue] = currentQueue;

        setBlinkingCard(currentToken.key);
        setIsSpeaking(true); // Mark as speaking

        // Play the token in Hindi (hi-IN) first
        playToken(currentToken, "hi-IN")
            .then(() => {
                // After Hindi finishes, play in English (en-IN)
                return playToken(currentToken, "en-IN");
            })
            .then(() => {
                // After both languages have been played, process the next token
                setQueue((prevQueue) => {
                    const nextQueue = prevQueue.slice(1); // Remove the processed token
                    if (nextQueue.length > 0) {
                        processQueue(nextQueue); // Continue processing the next token
                    } else {
                        setIsSpeaking(false); // No more tokens to process
                    }
                    return nextQueue; // Update the queue state
                });
            })
            .catch((error) => {
                console.error("Error during token playback:", error);
                setIsSpeaking(false); // Reset speaking state on error
            });
    };




    // Play a token in a specific language
    const playToken = async (token, language) => {
        return new Promise(async (resolve, reject) => {
            debugger;
            try {
                const response = await fetch("https://www.tokenapi.binix.co.in/api/TextToSpeech/generate-mp3", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        TokenNo: token.tokenNo,
                        DrName: token.drName,
                        Language: language,
                    }),
                });

                if (response.ok) {
                    debugger;
                    const audioBlob = await response.blob();
                    const audioUrl = URL.createObjectURL(audioBlob);
                    const audio = new Audio(audioUrl);

                    audio.onended = () => {
                        console.log(`Finished playing token ${token.tokenNo} in ${language}`);
                        resolve(); // Resolve when audio ends
                    };

                    audio.onerror = (e) => {
                        console.error(`Audio playback error for token ${token.tokenNo} in ${language}`, e);
                        reject(e); // Reject if there's an error
                    };
                    setIsSpeaking(true); // Mark as speaking
                    audio.play().catch((error) => {
                        console.error(`Audio play() blocked for ${token.tokenNo} in ${language}`, error);
                        reject(error); // Reject if playback is blocked
                    });
                } else {
                    console.error(`Error generating MP3 for token ${token.tokenNo} in ${language}`);
                    reject(new Error(`Error generating MP3 for ${language}`));
                }
            } catch (error) {
                console.error(`Error during fetch for token ${token.tokenNo} in ${language}:`, error);
                reject(error);
            }
        });
    };


    // Play token in both languages (hi-IN, en-IN) sequentially
    const playTokenInLanguages = async (token) => {
        if (isSpeaking) {
            console.warn("Already speaking. Queuing token.");
            setQueue((prevQueue) => [...prevQueue, token]);
            return;
        }

        setIsSpeaking(true); // Mark as speaking
        try {
            // Play in Hindi first
            await playToken(token, "hi-IN");
            // Then play in English
            await playToken(token, "en-IN");
        } catch (error) {
            console.error("Error during playback:", error);
        } finally {
            setIsSpeaking(false); // Mark as not speaking after both playbacks

            // Process the next token in the queue
            if (queue.length > 0) {
                const nextToken = queue[0];
                setQueue((prevQueue) => prevQueue.slice(1)); // Remove the current token from the queue
                playTokenInLanguages(nextToken); // Play the next token
            }
        }
    };



    // Generate and Play MP3
    const generateAndPlayMp3hi = async (token) => {
        setIsSpeaking(true); // Mark as speaking (prevent new playbacks)
        debugger;
        try {
            const response = await fetch("https://www.tokenapi.binix.co.in/api/TextToSpeech/generate-mp3", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    TokenNo: token.tokenNo,   // Token number
                    DrName: token.drName,     // Doctor's name
                    Language: token.language  // Language (for speech synthesis, etc.)
                }),

            });

            if (response.ok) {
                const audioBlob = await response.blob(); // Get the audio as a blob
                const audioUrl = URL.createObjectURL(audioBlob); // Create an object URL from the blob
                const audio = new Audio(audioUrl); // Create an Audio element

                audio.onended = () => {
                    generateAndPlayMp3en(token);
                    setIsSpeaking(false); // Mark as not speaking once the audio ends
                    console.log("Audio playback finished");

                    // Check if there is any token in the queue after the current one finishes
                    if (queue.length > 0) {
                        const nextToken = queue[0]; // Get the next token in the queue
                        setQueue((prevQueue) => prevQueue.slice(1)); // Remove the played token from the queue

                        generateAndPlayMp3hi(nextToken); // Play the next token
                    }
                };

                audio.play(); // Play the audio
            } else {
                console.error("Error generating MP3.");
                setIsSpeaking(false); // In case of failure, reset the speaking state
            }
        } catch (error) {
            console.error("Error:", error);
            setIsSpeaking(false); // In case of failure, reset the speaking state
        }
    };

    const generateAndPlayMp3en = async (token) => {
        setIsSpeaking(true); // Mark as speaking (prevent new playbacks)
        debugger;
        try {
            const response = await fetch("https://www.tokenapi.binix.co.in/api/TextToSpeech/generate-mp3", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    TokenNo: token.tokenNo,   // Token number
                    DrName: token.drName,     // Doctor's name
                    Language: 'en-IN'  // Language (for speech synthesis, etc.)
                }),

            });

            if (response.ok) {
                const audioBlob = await response.blob(); // Get the audio as a blob
                const audioUrl = URL.createObjectURL(audioBlob); // Create an object URL from the blob
                const audio = new Audio(audioUrl); // Create an Audio element

                audio.onended = () => {

                    setIsSpeaking(false); // Mark as not speaking once the audio ends
                    console.log("Audio playback finished");

                    // Check if there is any token in the queue after the current one finishes

                };

                audio.play(); // Play the audio
            } else {
                console.error("Error generating MP3.");
                setIsSpeaking(false); // In case of failure, reset the speaking state
            }
        } catch (error) {
            console.error("Error:", error);
            setIsSpeaking(false); // In case of failure, reset the speaking state
        }
    };


    const loadVoices = async () => {
        const voicesPromise = new Promise((resolve) => {
            let voices = speechSynthesis.getVoices();
            if (voices.length > 0) {
                resolve(voices);
            } else {
                speechSynthesis.onvoiceschanged = () => {
                    voices = speechSynthesis.getVoices();
                    resolve(voices);
                };
            }
        });

        const voices = await voicesPromise;
        initializeVoices(voices);
    };

    const initializeVoices = (voices) => {
        const hindi = voices.find((voice) => voice.lang === "hi-IN");
        const english = voices.find((voice) => voice.lang === "en-IN");
        setHindiVoice(hindi || voices[0]); // Fallback to first voice if Hindi unavailable
        setEnglishVoice(english || voices[0]); // Fallback to first voice if English unavailable

        if (hindi || english) {
            setVoicesLoaded(true);
        } else {
            console.error("Required voices not found.");
            const silentUtterance = new SpeechSynthesisUtterance("Required voices not found.");
            speechSynthesis.speak(silentUtterance);
        }
    };


    const enableSpeech = async () => {
        await localforageWrapper.removeItem('myData');
        const silentUtterance = new SpeechSynthesisUtterance("Speech initialized");
        speechSynthesis.speak(silentUtterance);
        //await loadVoices();
        setIsSpeechEnabled(true);
        setTokenData([]);
    };

    // Expose enableSpeech to parent components
    useImperativeHandle(ref, () => ({
        enableSpeech,
    }));

    return (
        <div style={{ position: 'relative', overflow: 'hidden', height: '100vh' }}>
            {/* Confirmation Modal */}
            {showConfirmationModal && (
                <ConfirmationModal
                    message="Do you want to clear history?"
                    onConfirm={() => handleConfirmation(true)}
                    onCancel={() => handleConfirmation(false)}
                />
            )}

            {/* Background Video */}
            <video
                ref={videoRef}
                autoPlay
                loop
                muted
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    zIndex: -1, // Ensure video is behind the content
                }}
            >
                <source src="/video/sample.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            {/* Play Button */}
            <button
                onClick={handlePlayPause}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    fontSize: '24px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    display: 'none',
                }}
            >
                {isPlaying ? '⏸' : '▶'} {/* Show play or pause icon based on state */}
            </button>

            {/* Fallback Image Background */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundImage: 'url(/video/bgimage.jpg)', // Path to your fallback image
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: -2, // Ensure it's behind the video
                }}
            />
            {/* Content Overlay */}
            <div style={{ position: 'relative', zIndex: 1, margin: 10, }}>
                {/* <h2>Current Token: {currentToken || "No token received yet"}</h2> */}
                {tokenData && tokenData.length > 0 ? (
                    <div
                        style={{
                            display: 'flex',
                            gap: '16px', // Space between columns
                        }}
                    >
                        {Array.from({ length: Math.ceil(tokenData.length / 5) }, (_, columnIndex) => (
                            <div
                                key={columnIndex}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px', // Space between rows in each column
                                }}
                            >
                                {tokenData
                                    .slice(columnIndex * 5, columnIndex * 5 + 5) // Slice data dynamically for each column
                                    .map((node, rowIndex) => (
                                        <Card
                                            key={node.key || `${columnIndex}-${rowIndex}`} // Ensure unique keys
                                            className={blinkingCard === node.key ? 'card-blink' : ''}
                                            sx={{
                                                display: 'flex',
                                                margin: 0,
                                                padding: 0,
                                                minWidth: 350, // Set card width
                                                maxHeight: 90, // Set card height
                                                backgroundColor: blinkingCard === node.key ? 'lightyellow' : 'rgba(255, 255, 255, 0.6)', // Apply background color conditionally
                                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)', // Subtle shadow for better visibility
                                                backdropFilter: 'blur(5px)', // Optional blur effect for better contrast
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '35%',
                                                    backgroundColor: 'rgba(211, 211, 211, 0.6)', // Semi-transparent light grey
                                                }}
                                            >
                                                <CardContent sx={{ padding: 1 }}>
                                                    {/*  <Display
                                                        value={node.tokenNo}
                                                        color="#FF0000"
                                                        bakgroundColor="#000"
                                                        height="50"
                                                        count="3"
                                                        skew="false"
                                                    /> */}
                                                    <Typography
                                                        variant="h2"
                                                        component="div"
                                                        sx={{ color: 'blue', fontFamily: 'Arial, sans-serif' }}
                                                    >
                                                        {node.tokenNo}
                                                    </Typography>
                                                </CardContent>
                                            </Box>

                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    width: '65%',
                                                    paddingLeft: 1,
                                                    paddingBottom: 1,
                                                }}
                                            >
                                                <Typography component="div" sx={{ color: 'black', fontSize: 20 }}>
                                                    {node.drName}
                                                </Typography>
                                                <Typography
                                                    variant="subtitle1"
                                                    component="div"
                                                    sx={{ color: 'text.secondary', fontSize: 20 }}
                                                >
                                                    {node.description}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    ))}
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
        </div>
    );

});

export default TokenDisplayScreen;
